import React, { useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import styles from "./SideNav.module.css";
import logo from "../../assets/logo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressBook,
  faBox,
  faPercent,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import AuthContext from "../../store/AuthCtx";

function SideNav() {
  const AuthCtx = useContext(AuthContext);
  return (
    <div className={styles.container}>
      <div className={styles.subContainer}>
        <img
          alt="Logo"
          className={styles.image}
          style={{ margin: "auto" }}
          src={logo}
          width={200}
        />
        <NavLink
          className={({ isActive }) => (isActive ? styles.active : "")}
          to="/dashboard/rates"
        >
          <FontAwesomeIcon icon={faPercent} />
          Rates
        </NavLink>
        <NavLink
          className={({ isActive }) => (isActive ? styles.active : "")}
          to="/dashboard/boxes"
        >
          <FontAwesomeIcon icon={faBox} />
          Boxes
        </NavLink>
        <NavLink
          className={({ isActive }) => (isActive ? styles.active : "")}
          to="/dashboard/address"
        >
          <FontAwesomeIcon icon={faAddressBook} />
          Addresses
        </NavLink>
        <Link onClick={() => AuthCtx.logout()}>
          <FontAwesomeIcon icon={faRightFromBracket} />
          Logout
        </Link>
      </div>
    </div>
  );
}

export default SideNav;
